

export class mdlPremiumMainCoversCompRenewal {
    public CoverCode: string;
    public CoverDescription: string;
    public CoverDescription_Ar: string;
    public Price: number;
    public Quantity: number;
    public GrossAmount: number;
    public NCDPercent: number;
    public NCDAmount: number;
    public LDPercent: number;
    public LDAmount: number;
    public UserDiscPer: number;
    public UserDiscount: number;
    public PromoDiscPer: number;
    public PromoDiscAmount: number;
    public OtherDiscPer: number;
    public OtherDiscAmount: number;
    public OtherDiscDeductionType: string;
    public CrossSellDiscPer: number;
    public CrossSellDiscAmount: number;
    public CrossSellDeductionType: string;
    public DriverDiscPer: number;
    public DriverDiscAmount: number;
    public DriverDeductionType: string;
    public TotalPrice: number;
    public LoadingTypes: string;
    public RateType: string;
    public AgeLoading: number;
    public IsBrokerComm: boolean;
    public IsBasic: boolean;
    public IsMandatory: boolean;
    public IsDefault: boolean;
    public IsAddToSI: boolean;
    public PremLogiccode: number;
    public SumInsured: number;
    public Rate: number;
    public Deductable: number;
    public TariffId: number;
    public Vat_Per: number;
    public Vat_Amount: number;
    public Extension_Days: number | null;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlPremiumMainCoversCompRenewal.ts